module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.58aef54.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Medium.ttf
// module id = BEBZ
// module chunks = 1